import * as d3 from 'd3';
Oskari.clazz.define('Oskari.userinterface.component.Chart', function () {
  this.svg = null;
  this.dimensions = {};
  this.x = null;
  this.y = null;
  this.colorScale = null;
  this.data = null;
  this.chartType = null;
  this.plot = jQuery('<div style="width:100%"></div>');
  this.axisLabelValues = jQuery('<div style="width:100%"></div>');
  this.sortingType = null;
  this._g = null;
  this._options = {
    colors: ['#555', '#555'],
    width: 630,
    margin: {
      left: 50,
      right: 50,
      bottom: 15,
      top: 10,
      maxForLabel: 140
    },
    maxTicks: 10
  };
  this.loc = Oskari.getMsg.bind(null, 'DivManazer');
  this.calculateDimensions();
}, {
  setOptions: function setOptions() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var opts = jQuery.extend(true, {}, this._options, options);
    if (typeof opts.valueRenderer !== 'function') {
      opts.valueRenderer = null;
    }
    if (typeof opts.colors === 'string') {
      opts.colors = [opts.colors];
    }
    this._options = opts;
  },
  getOptions: function getOptions() {
    return this._options;
  },
  chartIsInitialized: function chartIsInitialized() {
    return this.svg !== null;
  },
  calculateDimensions: function calculateDimensions() {
    var _this$getOptions = this.getOptions(),
      width = _this$getOptions.width,
      _this$getOptions$marg = _this$getOptions.margin,
      top = _this$getOptions$marg.top,
      bottom = _this$getOptions$marg.bottom;
    var _this$getDimensionsFr = this.getDimensionsFromData(),
      labels = _this$getDimensionsFr.labels,
      dataset = _this$getDimensionsFr.dataset,
      axis = _this$getDimensionsFr.axis,
      height = _this$getDimensionsFr.height,
      _this$getDimensionsFr2 = _this$getDimensionsFr.margin,
      left = _this$getDimensionsFr2.left,
      right = _this$getDimensionsFr2.right;
    this.dimensions = {
      margin: {
        left: left,
        right: right,
        top: top,
        bottom: bottom
      },
      dataset: dataset,
      axis: axis,
      container: {
        width: width,
        height: height
      },
      chart: {
        width: width - left - right,
        height: height - bottom - top
      },
      labels: labels
    };
  },
  getDimensionsFromData: function getDimensionsFromData() {
    var pxPerChar = 5.5;
    var xLabelOffset = 15;
    var xOffset = -5;
    var _this$getOptions2 = this.getOptions(),
      width = _this$getOptions2.width,
      _this$getOptions2$mar = _this$getOptions2.margin,
      optLeft = _this$getOptions2$mar.left,
      optRight = _this$getOptions2$mar.right,
      maxForLabel = _this$getOptions2$mar.maxForLabel,
      maxTicks = _this$getOptions2.maxTicks;
    // default values if couldn't calculate from data
    var left = optLeft;
    var right = optRight;
    var min = 0;
    var max = 0;
    var ticks = 0;
    var height = 0;
    var positive = 0;
    var negative = 0;
    if (this.data) {
      height = this.data.length * 21;
      min = d3.min(this.data, function (d) {
        return d.value;
      });
      max = d3.max(this.data, function (d) {
        return d.value;
      });
      var widestLabel = d3.max(this.data, function (d) {
        return d.name.length;
      });
      var labelPx = widestLabel * pxPerChar;
      var labelMargin = labelPx < maxForLabel ? labelPx : maxForLabel;
      var chartWidth = width - left - right;
      var x = d3.scaleLinear().domain(this.getScaleArray(min, max)).range([0, chartWidth]);
      var xOrigin = x(0);
      // calculate how much space is needed for labels, if negative then label fits inside chart
      var spaceForPositive = labelMargin - xOrigin;
      var spaceForNegative = xOrigin + labelMargin - chartWidth;
      if (spaceForPositive > 0) {
        left = spaceForPositive + optLeft / 2;
      }
      if (spaceForNegative > 0) {
        right = spaceForNegative + optRight / 2;
      }
      // update chart width
      chartWidth = width - left - right;
      xOrigin = x.range([0, chartWidth])(0);
      // calculate max label lengths and ticks
      positive = Math.floor((left + xOrigin - xLabelOffset) / pxPerChar);
      negative = Math.floor((right + chartWidth - xOrigin - xLabelOffset) / pxPerChar);
      var xDigits = Math.floor(Math.log(Math.max(Math.abs(min), max)) * Math.LOG10E + 1);
      var tickTarget = Math.floor(chartWidth / xDigits / 10);
      ticks = tickTarget > maxTicks ? maxTicks : tickTarget;
    }
    return {
      height: height,
      dataset: {
        min: min,
        max: max
      },
      axis: {
        ticks: ticks,
        xOffset: xOffset
      },
      margin: {
        left: left,
        right: right
      },
      labels: {
        positive: positive,
        negative: negative
      }
    };
  },
  initScales: function initScales() {
    // from zero to max value. This could also be from min to max value, but it causes problems if
    // some values are missing -> resulting to negative widths for bars.
    // TODO: we need some proper handling for missing values AND negative values.

    this.x = d3.scaleLinear();
    this.y = d3.scaleBand();
    var _this$dimensions$data = this.dimensions.dataset,
      min = _this$dimensions$data.min,
      max = _this$dimensions$data.max;
    var xScaleDomain = this.getScaleArray(min, max);
    var yScaleDomain = this.data.map(function (d) {
      return d.name;
    });
    this.x.domain(xScaleDomain);
    this.y.domain(yScaleDomain);
  },
  getScaleArray: function getScaleArray(min, max) {
    if (min > 0) {
      return [0, max];
    }
    if (max < 0) {
      return [min, 0];
    }
    return [min, max];
  },
  getSVGTemplate: function getSVGTemplate() {
    var _this$dimensions = this.dimensions,
      container = _this$dimensions.container,
      margin = _this$dimensions.margin;
    var svg = d3.select(this.plot.get(0)).append('svg').attr('width', container.width).attr('height', container.height).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
    return svg;
  },
  nullsLast: function nullsLast(a, b) {
    if (a == null && b == null) return 0;
    if (a == null) return -1;
    if (b == null) return 1;
    return 0;
  },
  /**
   *
   * @method sortDataByType
   * @param { String } type - indicates what sort of sorting we want to apply to our chart.
   * if no type provided it will default to value ascending
   */
  sortDataByType: function sortDataByType(type) {
    var me = this;
    // empty string ("") is the placeholder value from selectlist
    if (!this.sortingType) {
      if (typeof type === 'undefined' || type === '') {
        type = 'value-descending';
      }
    } else if (type === undefined || type === '') {
      type = this.sortingType;
    }
    switch (type) {
      case 'name-ascending':
        me.data.sort(function (a, b) {
          return d3.descending(a.name, b.name);
        });
        break;
      case 'name-descending':
        me.data.sort(function (a, b) {
          return d3.ascending(a.name, b.name);
        });
        break;
      case 'value-ascending':
        me.data.sort(function (a, b) {
          var result = me.nullsLast(a.value, b.value);
          if (!result) {
            return d3.descending(a.value, b.value);
          }
          return result;
        });
        break;
      case 'value-descending':
        me.data.sort(function (a, b) {
          var result = me.nullsLast(a.value, b.value);
          if (!result) {
            return d3.ascending(a.value, b.value);
          }
          return result;
        });
        break;
    }
    me.redraw();
    me.sortingType = type;
  },
  /**
   * d3 axis are functions that generate svg-elements based on the scale given
   * @method initAxis
   *
   */
  initAxis: function initAxis() {
    var _this = this;
    var _this$dimensions2 = this.dimensions,
      height = _this$dimensions2.chart.height,
      _this$dimensions2$axi = _this$dimensions2.axis,
      ticks = _this$dimensions2$axi.ticks,
      xOffset = _this$dimensions2$axi.xOffset;
    this.xAxis = d3.axisTop(this.x).ticks(ticks).tickSizeInner(-height + xOffset).tickSizeOuter(0).tickFormat(function (d) {
      return _this.loc('graph.tick', {
        value: d
      });
    });
  },
  /**
   * initializes the chart skeleton without any specific line or bar options
   *
   * @method initChart
   *
   */
  initChart: function initChart() {
    this.svg = this.getSVGTemplate();
    this.initScales();
    var chart = this.chart(this.svg);
    return chart;
  },
  /**
   * sets this.data and sorts the values in ascending order
   *
   * @method handleData
   * @param  [] data only supports following format: [ { name: "", value: int } ]
   */
  handleData: function handleData(data) {
    if (!Array.isArray(data)) {
      return;
    }
    this.data = data;
    this.sortDataByType();
    this.calculateDimensions();
  },
  /**
   *
   * @method svgAppendElements
   */
  svgAppendElements: function svgAppendElements() {
    // append x-tick lines to chart
    var xtickAxis = this.svg.append('g').attr('class', 'x axis').attr('transform', 'translate( 0, 0)').attr('shape-rendering', 'crispEdges').call(this.xAxis);
    xtickAxis.selectAll('x axis, tick, text').remove();
    xtickAxis.select('.domain').remove();
    xtickAxis.selectAll('line').attr('stroke', '#eee');
    var _this$dimensions3 = this.dimensions,
      container = _this$dimensions3.container,
      margin = _this$dimensions3.margin;
    // append the x-axis to different element so we can show the values when scrollign
    var height = 12;
    var gx = d3.select(this.axisLabelValues.get(0)).append('svg').attr('width', container.width).attr('height', height).append('g').attr('class', 'x axis header').attr('transform', 'translate(' + margin.left + ',' + height + ')').call(this.xAxis);
    gx.select('.domain').remove();
    gx.selectAll('line').remove();

    // / X
  },
  /**
   * @method setColorScale
   */
  setColorScale: function setColorScale(colors) {
    if (Array.isArray(colors)) {
      this.colorScale = d3.scaleThreshold().range(colors);
    } else {
      this.colorScale = d3.scaleThreshold().domain(colors.bounds).range(colors.values);
    }
  },
  /**
   * handles data & options passed to it, initializes skeleton chart and then applies barchart specific options to the element
   * @method createBarChart
   * @param [Array] data
   * @param { Object } options keys: colors -> color scale, valueRenderer -> function for rendering bar values
   */
  createBarChart: function createBarChart(data, options) {
    this.setOptions(options);
    if (this.svg === null) {
      this.handleData(data);
    }
    var _this$getOptions3 = this.getOptions(),
      colors = _this$getOptions3.colors,
      valueRenderer = _this$getOptions3.valueRenderer;
    this.setColorScale(colors);
    this.initChart();
    var me = this;
    // labels
    var labels = this.svg.append('g').selectAll('.labels').data(this.data).enter().append('g').attr('class', function (d) {
      return d.value < 0 ? 'labels negative' : 'labels positive';
    }).attr('transform', function (d) {
      var marginized = me.y(d.name) + 11;
      return 'translate(' + me.x(0) + ',' + marginized + ')';
    });
    // append lines
    labels.append('line').attr('x2', function (d) {
      if (d.value < 0) {
        return 5;
      } else {
        return -5;
      }
    }).attr('y1', 0).attr('y2', 0).attr('x1', 0).attr('stroke', '#aaa').attr('shape-rendering', 'crispEdges');
    // append text
    var maxLabels = this.dimensions.labels;
    labels.append('text').attr('text-anchor', function (d) {
      if (d.value < 0) {
        return 'start';
      }
      return 'end';
    }).attr('x', function (d) {
      if (d.value < 0) {
        return 8;
      } else {
        return -8;
      }
    }).attr('dy', '0.32em').style('font-size', '11px').attr('fill', '#000').text(function (d) {
      return me.getTextContent(d, maxLabels);
    });

    // bars
    var bars = this.svg.insert('g', 'g.y').selectAll('.bar').data(this.data).enter().append('g').attr('class', function (d) {
      return d.value < 0 ? 'negative' : 'positive';
    }).attr('transform', function (d) {
      return 'translate(0,' + (me.y(d.name) + me.y.bandwidth() / 2) + ')';
    });
    function barWidth(d) {
      return d.value ? Math.abs(me.x(d.value) - me.x(0)) : 0;
    }
    ;

    // append rects
    bars.append('rect').attr('class', 'bar').attr('text-anchor', 'middle').style('fill', function (d, i) {
      return me.colorScale(d.value);
    }).attr('y', -8) // 7 is half of 15 height (pixel aligned)
    .attr('x', function (d) {
      return d.value ? me.x(Math.min(0, d.value)) : 0;
    }).attr('height', 17).attr('width', barWidth);
    // append text
    var noValStr = this.loc('graph.noValue');
    bars.each(function (d, i) {
      var isNumber = typeof d.value === 'number';
      if (!valueRenderer && isNumber) {
        return;
      }
      var textAnchor = 'start';
      var transformX = '5px';
      var locationX = me.x(0);
      var rendered = noValStr;
      var color = '#999';
      if (isNumber) {
        locationX = me.x(d.value);
        var width = barWidth(d);
        rendered = valueRenderer(d.value);
        var renderedLength = typeof rendered === 'string' ? rendered.length * 8 : 0; // 8px per char (generous)
        var fitsInBar = renderedLength < width - 10; // padding of 5px + 5px
        if (fitsInBar) {
          color = Oskari.util.isDarkColor(me.colorScale(d.value)) ? '#fff' : '#000';
          if (d.value >= 0) {
            textAnchor = 'end';
            transformX = '-5px';
          }
        } else {
          color = '#333';
          if (d.value < 0) {
            textAnchor = 'end';
            transformX = '-5px';
          }
        }
      }
      d3.select(this).append('text').attr('x', locationX).attr('text-anchor', textAnchor).attr('dx', transformX).attr('y', 0).attr('dy', isNumber ? '0.425em' : '0.32em').style('font-size', '11px').attr('fill', color).text(rendered);
    });
    this.chartType = 'barchart';
    return this.getGraph();
  },
  /**
   * handles data & options passed to it, initializes skeleton chart and then applies linechart specific options to the element
   * @method createLineChart
   */
  createLineChart: function createLineChart(data, options) {
    this.setOptions(options);
    this.handleData(data);
    var _this$getOptions4 = this.getOptions(options),
      colors = _this$getOptions4.colors;
    this.setColorScale(colors);
    this.initChart();
    var me = this;
    var linegen = d3.line().x(function (d) {
      return me.x(d.value);
    }).y(function (d) {
      return me.y(d.name);
    });
    this.svg.append('path').attr('d', linegen(this.data)).attr('stroke', function (d, i) {
      return me.colorScale(d.value);
    }).attr('stroke-width', 2).attr('fill', 'none');
    this.chartType = 'linechart';
    return this.getGraph();
  },
  getTextContent: function getTextContent(d, maxLength) {
    var max = d.value < 0 ? maxLength.negative : maxLength.positive;
    if (d.name.length > max) {
      return d.name.substring(0, max - 3) + "\u2026"; // ellipsis
    }
    return d.name;
  },
  /**
   * skeleton chart with no data applied to it
   * @method chart
   * @param  d3 svg-element
   */
  chart: function chart(selection) {
    var me = this;
    var _this$dimensions$char = this.dimensions.chart,
      height = _this$dimensions$char.height,
      width = _this$dimensions$char.width;
    // update x & y scales
    this.y.range([height, 0]);
    this.x.range([0, width]);
    selection.each(function (data) {
      me.initAxis();
      me.svgAppendElements();
    });
  },
  clear: function clear() {
    this.plot.empty();
    this.axisLabelValues.empty();
  },
  /**
   * remove old graph and redraw
   * @method redraw
   * @param  [data]
   */
  redraw: function redraw(data, options) {
    this.setOptions(options);
    var chart;
    this.handleData(data);

    // Clear previous graphs
    this.clear();
    if (this.chartType === 'barchart') {
      chart = this.createBarChart(this.data, options);
    } else if (this.chartType === 'linechart') {
      chart = this.createLineChart(this.data, options);
    }
    return chart;
  },
  getGraphAxisLabels: function getGraphAxisLabels() {
    return this.axisLabelValues;
  },
  getGraph: function getGraph() {
    return this.plot;
  }
});